export default __webpack_public_path__ + "static/swvl-7-b-62c7dbe837b135fae8c64c981a5a5ad6.webp";